<script setup>
const props = defineProps({
  errors: {
    type: [Array, Object, Boolean],
    default(){
      return [];
    },
    help: {
      type: [String, Boolean],
      default: false
    }
  }
});
</script>
<template>
  <div v-if="props.errors.length"
       class="text-alert-error text-sm mt-1">
    {{ props.errors[0] }}
  </div>
  <div v-else-if="props.help"
       class="text-stone-500 text-sm mt-1"
       v-text="props.help"></div>
</template>